export enum StatusExclusaoCentroCustoEnum {
    Excluido = 1,
    BloqueadoMovimentacao = 2,
    NaoEncontrado = 3,
}
